import * as cms from '../../common/api/cms';

export const FETCH_NEARBY_REGION = 'FETCH_NEARBY_REGION';
export const FETCH_NEARBY_REGION_SUCCESS = 'FETCH_NEARBY_REGION_SUCCESS';
export const FETCH_NEARBY_REGION_FAILURE = 'FETCH_NEARBY_REGION_FAILURE';

export const fetchNearbyRegionByCoordinates = (coordinates, fetch = true) => async (dispatch) => {
  dispatch({ type: FETCH_NEARBY_REGION });

  try {
    const nearbyRegion = fetch ? await cms.fetchNearbyRegionByCoordinates(coordinates) : {};
    dispatch({
      type: FETCH_NEARBY_REGION_SUCCESS,
      nearbyRegion,
    });
  } catch (err) {
    dispatch({
      type: FETCH_NEARBY_REGION_FAILURE,
      error: err,
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/cms/nearbyRegion.js